export default {
    createBox:(renderer,text,attr = {
            },styleBox ={})=>{
        const box  = text.getBBox(true);
        const defaultStyleBox = {borderBottom:2,borderRigth:2,y:0,x:0}
        const {borderBottom,borderRigth,y,x} = {...defaultStyleBox,...styleBox}
        const defaultAtrr = {fill:'#fff','stroke-width':'1px',zIndex: 4,rx:1,ry:1}


        text.translate(-box.width/2, 0);
        return renderer.rect(
            box.x - (box.width/2) + x,
            box.y + y,
            box.width + borderRigth,
            box.height + borderBottom)
            .attr({...defaultAtrr,...attr}).add();            
        },
    createPath:(renderer,path,atrr) => {
            return renderer.path(path)
            .attr(atrr).add();
        },
    createText:(renderer,text,x,y,attr,css) =>{
            return renderer
            .text(text,x,y)
            .attr(attr)
            .css(css)
            .add()
        }
}